import React, { useState, useEffect } from 'react'
import { Box, TextInput, Flex, Group, Button, Select, NumberInput, Text, Loader } from '@mantine/core'
import { useDebouncedCallback } from '@mantine/hooks'
import LoadingData from '../../../../ui/LoadingData'
import { getAllSupplierList } from '../../../../../services/supplier'
import { getAllCityList, getAllCountryList, getAllDistrictList, getAllProvinceList } from '../../../../../services/location'
import { getAllWarehouseList } from '../../../../../services/warehouse'
import { validation } from '../../../../../plugins/validation'
import { editProduct } from '../../../../../services/products'
import { notificationError, notificationSuccess } from '../../../../ui/Notifications'

const defaultVal = {
  id: null,
  title: '',
  slug: '',
  supplier_id: '',
  country_id: '',
  province_id: '',
  city_id: '',
  district_id: '',
  warehouse_id: '',
  sku: '',
  ali_sku: '',
  quantity: 0,

}

const formValidation = {
  title: {
    isError: false,
    message: ''
  },
  slug: {
    isError: false,
    message: ''
  },
  ali_sku: {
    isError: false,
    message: ''
  },
  sku: {
    isError: false,
    message: ''
  },
  supplier_id: {
    isError: false,
    message: ''
  },
  country_id: {
    isError: false,
    message: ''
  },
}

const FormSubProduct = ({ dataSubProduct, onCloseModal, reloadList }) => {
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)
  const [loadingData, setLoadingData] = useState(true)

  // supplier
  const [supplierList, setSupplierList] = useState([])
  const [searchSupplier, setSearchSupplier] = useState('')
  const [loadingSupplier, setLoadingSupplier] = useState(false)

  // countries
  const [countryList, setCountryList] = useState([])
  // province
  const [provinceList, setProvinceList] = useState([])
  // city
  const [cityList, setCityList] = useState([])
  // district
  const [districtList, setDistrictList] = useState([])

  // warehouse
  const [warehouseList, setWarehouseList] = useState([])

  const submitSubProduct = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    let validateForm = {}
    validateForm = {
      title: form.title,
      slug: form.slug,
      ali_sku: form.ali_sku,
      sku: form.sku,
      supplier_id: form.supplier_id,
      country_id: form.country_id,
    }
    
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }

    const payload = {
      title: form.title,
      slug: form.slug,
      supplier_id: form.supplier_id !== '' ? parseInt(form.supplier_id) : null,
      country_id: form.country_id !== null ? parseInt(form.country_id) : null,
      province_id: form.province_id !== null ? parseInt(form.province_id) : null,
      city_id: form.city_id !== null ? parseInt(form.city_id) : null,
      district_id: form.district_id !== null ? parseInt(form.district_id) : null,
      warehouses: form.warehouse_id !== '' ? [parseInt(form.warehouse_id)] : [],
      sku: form.sku,
      ali_sku: form.ali_sku,
      quantity: form.quantity,
    }

    try {
      const response = await editProduct(formData.id, payload)
      if (response.success) {
        onCloseModal()
        reloadList()
        notificationSuccess('Success', 'submit sub product success')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const errorMessageForm = error.response.data.errors
      const errorAliSku = errorMessageForm.ali_sku

      const message = errorAliSku
        ? 'The Ali Sku is already Registered. Please use a different Ali Sku.'
        : errorMessage
          ? errorMessage
          : 'Please contact your administrator'
      notificationError('Update Sub Product Error', message)

      if (errorMessageForm) {
        Object.keys(errorMessageForm).forEach((key) => {
          setValidationForm((oldVal) => ({...oldVal, [key]: { isError: true, message: errorMessageForm[key][0] }}))
        })
      }
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetListSupplier = useDebouncedCallback(async (supplierId) => {
    setLoadingSupplier(true)
    const parameter = {
      'filter[id][is]': supplierId,
      'filter[name][like]': searchSupplier,
      'page[num]': 1,
      'page[limit]': 10, // bad habbit
      'fields[supplier]': 'name'
    }

    try {
      const response = await getAllSupplierList(parameter)
      const dataSuppliers = response.data
      const remapDataSuppliers = dataSuppliers.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setSupplierList(remapDataSuppliers)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSupplier(false)
      setLoadingData(false)
    }
  }, 300)

  const handleGetCountries = async () => {
    setLoadingData(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 253, // bad habbit
      'fields[country]': 'name'
    }

    try {
      const response = await getAllCountryList(parameter)
      const dataCountries = response.data
      const remapDataCountries = dataCountries.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCountryList(remapDataCountries)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingData(false)
    }
  }

  const handleGetListProvince = async (idCountry) => {
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'filter[countries.id][is]': idCountry,
      'fields[province]': 'name',
    }
    try {
      const response = await getAllProvinceList(parameter)
      const dataProvince = response.data
      const remapDataProvince = dataProvince.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setProvinceList(remapDataProvince)
    } catch (error) {
      console.log(error)
    }
  }

  const handleGetListCity = async (idCountry, idProvince) => {
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'filter[countries.id][is]': idCountry,
      'filter[provinces.id][is]': idProvince,
      'fields[City]': 'name',
    }
    try {
      const response = await getAllCityList(parameter)
      const dataCity = response.data
      const remapDataCity = dataCity.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCityList(remapDataCity)
    } catch (error) {
      console.log(error)
    }
  }

  const handleGetListDistrict = async (idCountry, idProvince, idCity) => {
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'filter[countries.id][is]': idCountry,
      'filter[provinces.id][is]': idProvince,
      'filter[cities.id][is]': idCity,
      'fields[City]': 'name',
    }
    try {
      const response = await getAllDistrictList(parameter)
      const dataDistrict = response.data
      const remapDataDistrict = dataDistrict.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setDistrictList(remapDataDistrict)
    } catch (error) {
      console.log(error)
    }
  }

  const handleGetListWarehouse = async () => {
    const parameter = {
      'page[num]': 1,
      'page[limit]': 25, // bad habbit
      'sort': '-created_at'
    }

    try {
      const response = await getAllWarehouseList(parameter)
      const dataWarehouses = response.data
      const remapDataWarehouses = dataWarehouses.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setWarehouseList(remapDataWarehouses)
    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    handleGetListSupplier()
    // eslint-disable-next-line
  }, [searchSupplier])

  useEffect(() => {
    if (formData.country_id) {
      handleGetListProvince(formData.country_id)
    }
    // eslint-disable-next-line
  }, [formData.country_id])
  useEffect(() => {
    if (formData.country_id && formData.province_id) {
      handleGetListCity(formData.country_id, formData.province_id)
    }
    // eslint-disable-next-line
  }, [formData.province_id])
  useEffect(() => {
    if (formData.country_id && formData.province_id && formData.city_id) {
      handleGetListDistrict(formData.country_id, formData.province_id, formData.city_id)
    }
    // eslint-disable-next-line
  }, [formData.city_id])

  useEffect(() => {
    if (dataSubProduct) {
      if (dataSubProduct.supplier !== null) {
        handleGetListSupplier(dataSubProduct.supplier.id)
      }

      handleGetCountries()
      handleGetListWarehouse()
      handleSetForm(dataSubProduct)
    }
    // eslint-disable-next-line
  }, [dataSubProduct])

  const handleSetForm = (value) => {
    const dataDetail = {
      id: value.id,
      title: value.title || '',
      slug: value.slug || '',
      supplier_id: `${value.supplier?.id || ''}`,
      country_id: value.countryId ? String(value.countryId) : null,
      province_id: value.provinceId ? String(value.provinceId) : null,
      city_id: value.cityId ? String(value.cityId) : null,
      district_id: value.districtId ? String(value.districtId) : null,
      warehouse_id: `${value.warehouse?.id || ''}`,
      sku: value.sku || '',
      ali_sku: value.aliSku || '',
      quantity: value.quantity || 0,
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }
  const handleChangeFormCountry = (val) => {
    setFormData((oldVal) => ({ ...oldVal, country_id: val, province_id: null, city_id: null, district_id: null }))
  }
  const handleChangeFormProvince = (val) => {
    setFormData((oldVal) => ({ ...oldVal, province_id: val, city_id: null, district_id: null }))
  }
  const handleChangeFormCity = (val) => {
    setFormData((oldVal) => ({ ...oldVal, city_id: val, district_id: null }))
  }

  const mappingForm = (data) => {
    const loadingDataTemplate = () => {
        return (
          <Box ta='center' my={12}>
            <Loader size={16} />
            <Text c='gray.6' fz={11}>Loading Data</Text>
          </Box>
        )
      }

    return (
      <Box>
        <Box mb='md'>
          <TextInput
            label="Title"
            size='xs'
            withAsterisk
            value={formData.title}
            onChange={(event) => handleChangeForm('title', event.currentTarget.value)}
            error={validationForm.title.isError ? `${validationForm.title.message}` : ''}
          />
        </Box>

        <Box mb='md'>
          <TextInput
            label="Slug"
            size='xs'
            withAsterisk
            value={formData.slug}
            onChange={(event) => handleChangeForm('slug', event.currentTarget.value)}
            error={validationForm.slug.isError ? `${validationForm.slug.message}` : ''}
          />
        </Box>

        <Box mb='md'>
          <TextInput
            label="Original SKU"
            size='xs'
            withAsterisk
            value={formData.sku}
            onChange={(event) => handleChangeForm('sku', event.currentTarget.value)}
            error={validationForm.sku.isError ? `${validationForm.sku.message}` : ''}
          />
        </Box>

        <Box mb='md'>
          <TextInput
            label="Ali SKU"
            size='xs'
            withAsterisk
            value={formData.ali_sku}
            onChange={(event) => handleChangeForm('ali_sku', event.currentTarget.value)}
            error={validationForm.ali_sku.isError ? `${validationForm.ali_sku.message}` : ''}
          />
        </Box>

        <Box mb='md'>
          <NumberInput
            label="Stock"
            size='xs'
            value={formData.quantity}
            onChange={(event) => handleChangeForm('quantity', event)}
          />
        </Box>

        <Box mb='md'>
          <Select
            name='supplier_id'
            value={formData.supplier_id}
            label='Supplier'
            data={supplierList}
            onChange={(val) => handleChangeForm('supplier_id', val)}
            size='xs'
            searchable
            withAsterisk
            searchValue={searchSupplier}
            onSearchChange={setSearchSupplier}
            nothingFoundMessage={!loadingSupplier ? supplierList.length > 0 ? '' : 'No Supplier Found' : loadingDataTemplate()}
            clearable
            error={validationForm.supplier_id.isError ? `${validationForm.supplier_id.message}` : ''}
          />
        </Box>

        <Box mb='md'>
          <Select
            name='warehouse_id'
            value={formData.warehouse_id}
            label='Warehouse'
            data={warehouseList}
            onChange={(val) => handleChangeForm('warehouse_id', val)}
            size='xs'
            searchable
            nothingFoundMessage="No Warehouse found"
            clearable
          />
        </Box>

        <Box mb='md'>
          <Select
            name='country_id'
            value={formData.country_id}
            label='Country'
            data={countryList}
            onChange={(val) => handleChangeFormCountry(val)}
            size='xs'
            searchable
            clearable
            withAsterisk
            nothingFoundMessage="No Country found"
            error={validationForm.country_id.isError ? `${validationForm.country_id.message}` : ''}
          />
        </Box>

        <Box mb='md'>
          <Select
            name='province_id'
            value={formData.province_id}
            label='Province'
            data={provinceList}
            onChange={(val) => handleChangeFormProvince(val)}
            size='xs'
            searchable
            clearable
            nothingFoundMessage="No Province found"
            disabled={formData.country_id === null}
          />
        </Box>

        <Box mb='md'>
          <Select
            name='city_id'
            value={formData.city_id}
            label='City'
            data={cityList}
            onChange={(val) => handleChangeFormCity(val)}
            size='xs'
            searchable
            clearable
            nothingFoundMessage="No City found"
            disabled={formData.province_id === null}
          />
        </Box>
        <Box mb='md'>
          <Select
            name='district_id'
            value={formData.district_id}
            label='District'
            data={districtList}
            onChange={(val) => handleChangeForm('district_id', val)}
            size='xs'
            searchable
            clearable
            nothingFoundMessage="No District found"
            disabled={formData.city_id === null}
          />
        </Box>

        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
              <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitSubProduct(formData)}>{dataSubProduct !== null ? 'Update' : 'Create'}</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      {loadingData ? <LoadingData /> : mappingForm(dataSubProduct)}
    </Box>
  )
}

export default FormSubProduct